<template>
  <div>
    <div class="ts-mb-6 ts-bg-gray-100 ts-p-4  ts-rounded-lg">
      <!-- Student Name -->
      <div class="ts-mb-3">
        <div class="ts-text-sm ts-font-medium ts-text-gray-500">
          {{ $t('studentInsurance.studentName') }}
        </div>
        <div class="ts-text-base ts-text-gray-800">
          {{ editData.full_name_en }}
        </div>
      </div>

      <!-- Card ID -->
      <div class="ts-mb-3">
        <div class="ts-text-sm ts-font-medium ts-text-gray-500">
          {{ $t('studentInsurance.studentId') }}
        </div>
        <div class="ts-text-base ts-text-gray-800">
          {{ editData.card_number }}
        </div>
      </div>

      <!-- Phone Number -->
      <div>
        <div class="ts-text-sm ts-font-medium ts-text-gray-500">
          {{ $t('studentInsurance.phoneNumber') }}
        </div>
        <div class="ts-text-base ts-text-gray-800">
          {{ editData.phone }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <label class="required">{{ $t('studentInsurance.dateOfBirth') }}</label>
        <a-date-picker
          v-model="model.date_of_birth"
          valueFormat="YYYY-MM-DD"
          format="DD-MM-YYYY"
          :allowClear="false"
          class="ts-w-full"
        ></a-date-picker>
        <div class="ts-text-red-500 ts-mt-2" v-if="errors.has('date_of_birth')">
          {{ errors.first('date_of_birth') }}
        </div>
      </div>
    </div>
    <div class="row ts-mt-4">
      <div class="col-md-12 ts-flex ts-space-x-2 ts-justify-end">
        <a-button type="danger" @click.prevent="onsubmit">
          {{ $t('studentInsurance.reject') }}
        </a-button>
        <a-button type="primary" @click.prevent="onsubmit(true)">
          {{ $t('studentInsurance.approved') }}
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'insuranceAcknowledge',
  props: ['editData'],
  data() {
    return {
      errors: new Errors(),
      model: {
        date_of_birth: null,
        student_id: null,
        approved: false
      }
    }
  },
  created() {
    this.model.student_id = this.editData.student_id
  },
  methods: {
    onsubmit(approved = false) {
      this.loading = true
      this.model.approved = approved
      this.$store
        .dispatch('studentInsurance/acknowledgeInsurance', {
          id: this.editData.id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetch')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>
